import { OrderOperations } from "./OrderOperations"
import {
  OrderModificationShippingFees,
  OrderModificationType, ShippingFeeModificationUpdateData
} from "lib/types/generated/graphql-types"

export class ModificationShippingFees extends OrderOperations {
  constructor(modification: OrderModificationShippingFees[]) {
    super(
      modification?.filter((modification) => modification?.type === OrderModificationType?.ShippingFees)
    )
  }

  public onGoingModifications(): OrderModificationShippingFees[] {
    return this.onGoingList() as OrderModificationShippingFees[]
  }

  public failedModifications(): OrderModificationShippingFees[] {
    return this.failedList() as OrderModificationShippingFees[]
  }

  public getOngoingModification(): OrderModificationShippingFees {
    const onGoingList = this.onGoingList() as OrderModificationShippingFees[]
    return onGoingList[0]
  }

  public getPendingModification(): OrderModificationShippingFees {
    const pendingList = this.pendingList() as OrderModificationShippingFees[]
    return pendingList[0]
  }

    public updateOutputToInput(
      data: ShippingFeeModificationUpdateData
    ): ShippingFeeModificationUpdateData {
      return {
        id: data.id,
        taxGroupId: data.taxGroupId,
        price: {
          basePriceAmount: data?.price?.basePriceAmount ?? 0,
          salePriceAmount: data?.price?.salePriceAmount,
          taxPercentage: data?.price?.taxPercentage ?? 0,
        }
      }
    }
}
